(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-product-card"] && !Shopify.designMode) return;
  try {
    const page = document.querySelector('.template-list-collections');
  if (page) {
    const hoverMedia = matchMedia('(hover: hover) and (pointer: fine)');
    const loadHoverImage = (card) => {
      const template = card.querySelector('.collection-product-card__hover-template');
      if (!template) return;
      const image = template.content.querySelector('img').cloneNode(true);
      image.addEventListener('load', () => card.classList.add('is-photo-ready'), { once: true });
      card.querySelector('.collection-product-card__media').append(image);
      template.remove();
      if (image.complete && image.naturalWidth) card.classList.add('is-photo-ready');
    };
    page.addEventListener('pointerover', (event) => {
      const card = event.target.closest('.collection-product-card');
      if (!card || event.pointerType === 'touch' || !hoverMedia.matches) return;
      loadHoverImage(card);
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!hoverMedia.matches) return;
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          loadHoverImage(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '300px 0px' });
      const observeHoverImages = () => {
        observer.disconnect();
        if (!hoverMedia.matches) return;
        page.querySelectorAll('.collection-product-card__hover-template').forEach((template) => {
          observer.observe(template.closest('.collection-product-card'));
        });
      };
      observeHoverImages();
      hoverMedia.addEventListener('change', observeHoverImages);
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout-close-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('pointerdown', (event) => {
    const component = event.target.closest?.('layout-header, home-about');
    component?.classList.add('is-pointer-input');
  }, { passive: true });

  document.addEventListener('keydown', () => {
    document.querySelectorAll('layout-header.is-pointer-input, home-about.is-pointer-input').forEach((component) => {
      component.classList.remove('is-pointer-input');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
